module.exports = __webpack_public_path__ + "assets/img/image04.f63b1e9b.jpg";